import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { abonoActions } from '../../../application/actions/abonoInicial';

import api from '../../api';

const apiAbono = api(process.env.REACT_APP_ABONO_INICIAL);

export function* fetchAbono(action) {
  try {
    const { data } = yield call(apiAbono.get, 'v1/consultar', action.payload);
    if (data) yield put(abonoActions.fetchAbonoSuccess({data}));
    else yield put(abonoActions.fetchAbonoError());
  } catch (err) {
    yield put(abonoActions.fetchAbonoError());
  }
}
/* istanbul ignore next */
export function* watchFetchAbono() {
  yield takeLatest(abonoActions.fetchAbono.type, fetchAbono);
}
/* istanbul ignore next */
export default function* abonoSaga() {
  yield spawn(watchFetchAbono);
}
